import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode } from "vue";
const _hoisted_1 = { class: "row" };
import { inject, computed } from 'vue';
import { defineComponent } from 'vue';
const __default__ = defineComponent({
    name: 'app-multicolored-icon'
});
export default /*@__PURE__*/ _defineComponent({
    ...__default__,
    props: {
        iconClass: {
            type: Object,
            default: () => {
                return {};
            }
        },
        iconDivClass: {
            type: Object,
            default: () => {
                return {};
            }
        },
        icon: {
            type: String,
            required: true,
            validators: (value) => {
                return [
                    'getspaces',
                    'getproperty',
                    'profile',
                    'coworking',
                    'coworking-dark'
                ].indexOf(value) !== -1;
            }
        },
        customWidth: Number,
        customHeight: Number,
        iconSize: {
            type: Number,
            default: 50
        }
    },
    setup(__props) {
        const props = __props;
        // tried and tested additional padding to icon
        // for icon to look good
        const iconPaddingMultiplier = {
            getspaces: 1.25,
            getproperty: 1.25,
            profile: 1,
            coworking: 1,
            'coworking-dark': 1
        };
        // number of loops for icon (i.e number of colors that the icon has)
        const getIconLoopCount = inject('getIconLoopCount', {
            getspaces: 4,
            getproperty: 4,
            profile: 2,
            coworking: 2,
            'coworking-dark': 2
        });
        // 
        const iconDivStyle = computed(() => {
            return {
                'padding-right': `${(props.customWidth || props.iconSize) * iconPaddingMultiplier[props.icon]}px`,
                ...(props.customWidth || props.iconSize
                    ? {
                        width: `${props.customWidth || props.iconSize}px`
                    } : {}),
                ...(props.customHeight || props.iconSize
                    ? {
                        height: `${props.customHeight || props.iconSize}px`
                    } : {}),
            };
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", {
                    class: _normalizeClass(["self-center", {
                            ...__props.iconDivClass,
                            [`get-icon-${__props.icon}`]: true
                        }]),
                    style: _normalizeStyle(iconDivStyle.value)
                }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(getIconLoopCount)[__props.icon], (value) => {
                        return (_openBlock(), _createElementBlock("i", {
                            key: `multi-color-${value}`,
                            class: _normalizeClass([{
                                    ...__props.iconClass,
                                    [`path${value}`]: true
                                }, "icon-transform absolute"]),
                            style: _normalizeStyle(__props.iconSize ? {
                                'font-size': `${__props.iconSize}px`
                            } : {})
                        }, null, 6));
                    }), 128))
                ], 6)
            ]));
        };
    }
});
